import React from "react";
import Swiper from './swiper';
//SCSS
import "./partners.scss";

const partners = () => (
  <div id="partners">
    <div className="wrapper">
      <Swiper/>
    </div>
  </div>
);

export default partners;
